/* eslint no-empty:0 */
// from: https://github.com/fisshy/react-scroll/blob/master/modules/mixins/passive-event-listeners.js
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
const addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  const supportsPassiveOptionFunc = (function supportsPassiveOptionFunc() {
    let supportsPassiveOption = false;
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: function optionsGet() {
          supportsPassiveOption = true;
        },
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }());

  target.addEventListener(eventName, listener, supportsPassiveOptionFunc ? {
    passive: true,
  } : false);
};

// from: https://github.com/fisshy/react-scroll/blob/master/modules/mixins/scroll-spy.js
const eventThrottler = function eventThrottler(eventHandler) {
  let eventHandlerTimeout;
  return function eventThrottlerFunction(event) {
    // ignore events as long as an eventHandler execution is in the queue
    if (!eventHandlerTimeout) {
      eventHandlerTimeout = setTimeout(() => {
        eventHandlerTimeout = null;
        eventHandler(event);
        // The eventHandler will execute at a rate of 15fps
      }, 66);
    }
  };
};

export default {
  addPassiveEventListener,
  eventThrottler,
};



// WEBPACK FOOTER //
// ./src/utils/event.js